import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import Iconify from './Iconify';

// Added as a reusable back button component for each of the pages
export default function BackButton({ back, type }) {
  const theme = useTheme();

  const backButtonStyle = {
    padding: 2,
    pr: 1,
    pl: 0.5,
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    transition: 'background-color 0.3s',
    borderRadius: '12px',
    '&:hover': {
      backgroundColor: (hoverTheme) => hoverTheme.palette.grey[200],
    },
    maxWidth: 'fit-content',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    color: theme.palette.grey[900],
  };

  return (
    <Box onClick={() => back()}>
      <Box sx={backButtonStyle}>
        <Iconify icon="tabler:arrow-left" width={24} height={24} />
        <Typography variant="body1" sx={{ pl: 1, fontWeight: 'fontWeightMedium' }}>
          {type === 'booking' && 'Back to Bookings List'}
          {type === 'vehicle' && 'Back to Vehicles List'}
          {type === 'driver' && 'Back to Drivers List'}
          {type === 'user' && 'Back to Admin Users List'}
          {type === 'verification' && 'Back to E-KYC Verification List'}
          {type === 'passes' && 'Back to Passes List'}
          {type === 'operator' && 'Back to Operators List'}
          {type === 'promoCode' && 'Back to Promo Codes List'}
        </Typography>
      </Box>
    </Box>
  );
}
